import React, { useEffect } from "react";
import PageHeader from "../components/PageHeader";

const Produzione: React.FC = () => {
  useEffect(() => {
    document.title = "CO.ME.ST. S.R.L - Produzione";
  }, []);

  return (
    <div className="bg-white">
      <PageHeader title="Produzione" breadcrumb="Produzione" />
      <div className="container px-4 py-16 mx-auto">
        <div className="mx-auto max-w-5xl">
          <header className="mb-16 text-center">
            <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
              Produzione Stampaggio, Assemblaggio Lamiera, Alluminio e
              Realizzazione Attrezzature
            </h1>
          </header>

          {/* Stamping Section */}
          <section className="mb-16">
            <div className="p-8 bg-gradient-to-br from-gray-50 to-blue-50 rounded-3xl shadow-lg">
              <div className="grid gap-8">
                {/* Header Section */}
                <div className="text-center">
                  <h2 className="mb-4 text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                    Il Nostro Reparto Stampaggio
                  </h2>
                  <div className="mx-auto max-w-3xl">
                    <p className="text-xl leading-relaxed text-gray-700">
                      16 presse meccaniche ed idrauliche di alta qualità con
                      potenzialità da 80 a 500 tonnellate, asservite
                      mediante svolgitori automatici per garantire efficienza e
                      precisione costanti.
                    </p>
                  </div>
                </div>

                {/* 2x2 Grid: 3 Press Blocks + Image */}
                <div className="grid gap-6 md:grid-cols-2">
                  {/* High Power Presses */}
                  <div className="relative">
                    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-blue-500 to-blue-600 rounded-full"></div>
                    <div className="pl-6">
                      <div className="flex items-center mb-4">
                        <div className="p-2 mr-3 bg-blue-100 rounded-lg">
                          <svg
                            className="w-6 h-6 text-blue-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 10V3L4 14h7v7l9-11h-7z"
                            />
                          </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800">
                          Presse di Alta Potenza
                        </h3>
                      </div>
                      <div className="grid gap-3 sm:grid-cols-2">
                        <div className="p-3 bg-white rounded-xl border border-blue-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-blue-700">
                            Benelli 500T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-blue-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-blue-700">
                            Schuler 400T Idraulica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-blue-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-blue-700">
                            Rovetta 300T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-blue-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-blue-700">
                            Zani 300T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-blue-100 shadow-sm transition-shadow hover:shadow-md sm:col-span-2">
                          <h4 className="font-bold text-blue-700">
                            Benelli 300T Meccanica
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Image Section - Second block in grid */}
                  <div className="flex justify-center items-start">
                    <img
                      src="/images/prod.jpg"
                      alt="Reparto Stampaggio"
                      className="w-full h-auto rounded-2xl shadow-xl"
                    />
                  </div>

                  {/* Medium Power Presses */}
                  <div className="relative">
                    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-green-500 to-green-600 rounded-full"></div>
                    <div className="pl-6">
                      <div className="flex items-center mb-4">
                        <div className="p-2 mr-3 bg-green-100 rounded-lg">
                          <svg
                            className="w-6 h-6 text-green-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800">
                          Presse di Media Potenza
                        </h3>
                      </div>
                      <div className="grid gap-3 sm:grid-cols-2">
                        <div className="p-3 bg-white rounded-xl border border-green-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-green-700">
                            Pressix 250T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-green-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-green-700">
                            Colombo 250T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-green-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-green-700">
                            Balconi 250T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-green-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-green-700">
                            IMS 200T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-green-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-green-700">
                            Zani 200T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-green-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-green-700">
                            San Giacomo 200T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-green-100 shadow-sm transition-shadow hover:shadow-md sm:col-span-2">
                          <h4 className="font-bold text-green-700">
                            Müller 180T Idraulica
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Specialized Presses */}
                  <div className="relative">
                    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-500 to-orange-500 rounded-full"></div>
                    <div className="pl-6">
                      <div className="flex items-center mb-4">
                        <div className="p-2 mr-3 bg-amber-100 rounded-lg">
                          <svg
                            className="w-6 h-6 text-amber-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                            />
                          </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800">
                          Presse Specializzate
                        </h3>
                      </div>
                      <div className="grid gap-3 sm:grid-cols-2">
                        <div className="p-3 bg-white rounded-xl border border-amber-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-amber-700">
                            Pressix 130T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-amber-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-amber-700">
                            DMC 100T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-amber-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-amber-700">
                            Basetto 90T Meccanica
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-amber-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-amber-700">
                            Comonto 80T Meccanica
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom Message */}
                <div className="p-6 mt-8 bg-white rounded-2xl border-l-4 border-indigo-500 shadow-sm">
                  <p className="text-lg font-medium leading-relaxed text-gray-800">
                    Ogni macchina è scelta per la sua specifica eccellenza,
                    garantendo la soluzione ottimale per ogni tipo di
                    lavorazione e materiale.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Assembly Section */}
          <section className="mb-16">
            <div className="p-8 bg-gradient-to-br from-orange-50 to-red-50 rounded-3xl shadow-lg">
              <div className="grid gap-8">
                {/* Header Section */}
                <div className="text-center">
                  <h2 className="mb-4 text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-red-600">
                    Reparto Assemblaggio con Puntatura e Saldatura
                  </h2>
                  <div className="mx-auto max-w-3xl">
                    <p className="text-xl leading-relaxed text-gray-700">
                      Il nostro reparto assemblaggio è dotato di tecnologie
                      avanzate per saldature a punti e proiezione, garantendo
                      precisione e affidabilità in ogni processo di giunzione
                      metallica. Ognuna è dotata di nastro trasportatore munito
                      di fotocamere con sensore che permettono il controllo al
                      100% dei particolari prodotti.
                    </p>
                  </div>
                </div>

                {/* Content and Image Side by Side */}
                <div className="grid gap-8 items-start lg:grid-cols-2">
                  {/* Equipment Content */}
                  <div className="space-y-6">
                    {/* Spot Welders - High Power */}
                    <div className="relative">
                      <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-orange-500 to-orange-600 rounded-full"></div>
                      <div className="pl-6">
                        <div className="flex items-center mb-4">
                          <div className="p-2 mr-3 bg-orange-100 rounded-lg">
                            <svg
                              className="w-6 h-6 text-orange-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M13 10V3L4 14h7v7l9-11h-7z"
                              />
                            </svg>
                          </div>
                          <h3 className="text-2xl font-bold text-gray-800">
                            Puntatrici Alta Potenza
                          </h3>
                        </div>
                        <div className="grid gap-3 sm:grid-cols-2">
                          <div className="p-3 bg-white rounded-xl border border-orange-100 shadow-sm transition-shadow hover:shadow-md">
                            <h4 className="font-bold text-orange-700">
                              1x Tecna 160kW GEM
                            </h4>
                          </div>
                          <div className="p-3 bg-white rounded-xl border border-orange-100 shadow-sm transition-shadow hover:shadow-md">
                            <h4 className="font-bold text-orange-700">
                              3x Tecna 120kW GEM
                            </h4>
                          </div>
                          <div className="p-3 bg-white rounded-xl border border-orange-100 shadow-sm transition-shadow hover:shadow-md">
                            <h4 className="font-bold text-orange-700">
                              2x Tecna 80kW GEM
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Specialized Equipment */}
                    <div className="relative">
                      <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-yellow-500 to-orange-500 rounded-full"></div>
                      <div className="pl-6">
                        <div className="flex items-center mb-4">
                          <div className="p-2 mr-3 bg-yellow-100 rounded-lg">
                            <svg
                              className="w-6 h-6 text-yellow-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                              />
                            </svg>
                          </div>
                          <h3 className="text-2xl font-bold text-gray-800">
                            Attrezzature Specializzate
                          </h3>
                        </div>
                        <div className="grid gap-3 sm:grid-cols-2">
                          <div className="p-3 bg-white rounded-xl border border-yellow-100 shadow-sm transition-shadow hover:shadow-md">
                            <h4 className="font-bold text-yellow-700">
                              2x Tecna 35kW GEM
                            </h4>
                          </div>
                          <div className="p-3 bg-white rounded-xl border border-yellow-100 shadow-sm transition-shadow hover:shadow-md">
                            <h4 className="font-bold text-yellow-700">
                              1x Tecna 30kW GEM
                            </h4>
                          </div>
                          <div className="p-3 bg-white rounded-xl border border-yellow-100 shadow-sm transition-shadow hover:shadow-md sm:col-span-2">
                            <h4 className="font-bold text-yellow-700">
                              Isole Robotizzate
                            </h4>
                            <p className="mt-1 text-xs text-gray-600">
                              Saldatura MIG/MAG con maschere intercambiabili
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Controllo Qualità Section */}
                    <div className="relative">
                      <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-red-500 to-orange-500 rounded-full"></div>
                      <div className="pl-6">
                        <div className="flex items-center mb-4">
                          <div className="p-2 mr-3 bg-red-100 rounded-lg">
                            <svg
                              className="w-6 h-6 text-red-600"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                              />
                            </svg>
                          </div>
                          <h3 className="text-2xl font-bold text-gray-800">
                            Controllo Qualità
                          </h3>
                        </div>
                        <div className="p-4 bg-white rounded-xl border border-red-100 shadow-sm">
                          <h4 className="font-bold text-red-700">
                            Macchina METROCOM
                          </h4>
                          <p className="mt-1 text-gray-600">
                            Macchina elettromeccanica universale per prove di
                            tenuta e strappo.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Image Section */}
                  <div className="flex justify-center items-start">
                    <img
                      src="/images/prod2.jpg"
                      alt="Reparto Assemblaggio"
                      className="w-full h-auto rounded-2xl shadow-xl"
                    />
                  </div>
                </div>

                {/* Bottom Message */}
                <div className="p-6 mt-8 bg-white rounded-2xl border-l-4 border-orange-500 shadow-sm">
                  <p className="text-lg font-medium leading-relaxed text-gray-800">
                    Le nostre puntatrici Tecna con controllo GEM garantiscono
                    saldature a punti e proiezione di altissima qualità, con
                    controllo automatico dei parametri e ripetibilità
                    eccezionale per produzioni automotive. L'isola robotizzata
                    con robot KAWASAKI e maschere intercambiabili offre massima
                    flessibilità per componenti di diverse geometrie.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Manufacturing Equipment Section */}
          <section className="mb-16">
            <div className="p-8 bg-gradient-to-br from-purple-50 to-indigo-50 rounded-3xl shadow-lg">
              <div className="grid gap-8">
                {/* Header Section */}
                <div className="text-center">
                  <h2 className="mb-4 text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-indigo-600">
                    Attrezzature di Produzione e Realizzazione
                  </h2>
                  <div className="mx-auto max-w-3xl">
                    <div className="space-y-4 text-xl leading-relaxed text-gray-700">
                      <p>
                        I particolari prototipali sono realizzati direttamente
                        all'interno dell'officina Elpa Solutions o da fornitori
                        esterni selezionati.
                      </p>
                    </div>
                  </div>
                </div>

                {/* 2x2 Grid: Equipment Categories + Image */}
                <div className="grid gap-6 md:grid-cols-2">
                  {/* CNC Milling Machines */}
                  <div className="relative">
                    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-purple-500 to-purple-600 rounded-full"></div>
                    <div className="pl-6">
                      <div className="flex items-center mb-4">
                        <div className="p-2 mr-3 bg-purple-100 rounded-lg">
                          <svg
                            className="w-6 h-6 text-purple-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                            />
                          </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800">
                          Frese a Controllo Numerico (CNC)
                        </h3>
                      </div>
                      <div className="grid gap-3 sm:grid-cols-1">
                        <div className="p-3 bg-white rounded-xl border border-purple-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-purple-700">
                            Milling Correa CF-22 Plus
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-purple-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-purple-700">
                            Milling Eikon MVL 2000
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-purple-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-purple-700">
                            Milling Correa Prisma
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-purple-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-purple-700">
                            Sachman T20 HS 2000
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Image Section - Second block in grid */}
                  <div className="flex justify-center items-start">
                    <img
                      src="/images/proto.jpg"
                      alt="Attrezzature di Produzione"
                      className="w-full h-auto rounded-2xl shadow-xl"
                    />
                  </div>

                  {/* Lathes */}
                  <div className="relative">
                    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-indigo-500 to-indigo-600 rounded-full"></div>
                    <div className="pl-6">
                      <div className="flex items-center mb-4">
                        <div className="p-2 mr-3 bg-indigo-100 rounded-lg">
                          <svg
                            className="w-6 h-6 text-indigo-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800">
                          Torni
                        </h3>
                      </div>
                      <div className="grid gap-3 sm:grid-cols-1">
                        <div className="p-3 bg-white rounded-xl border border-indigo-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-indigo-700">
                            Bulcon V 3500
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-indigo-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-indigo-700">
                            Tornio Parallelo Ursus 250
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Special Equipment */}
                  <div className="relative">
                    <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-cyan-500 to-blue-500 rounded-full"></div>
                    <div className="pl-6">
                      <div className="flex items-center mb-4">
                        <div className="p-2 mr-3 bg-cyan-100 rounded-lg">
                          <svg
                            className="w-6 h-6 text-cyan-600"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 10V3L4 14h7v7l9-11h-7z"
                            />
                          </svg>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800">
                          Attrezzature Speciali
                        </h3>
                      </div>
                      <div className="grid gap-3 sm:grid-cols-1">
                        <div className="p-3 bg-white rounded-xl border border-cyan-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-cyan-700">
                            Elettrorosione EDM Agie Charmilles CUT30
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-cyan-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-cyan-700">
                            Troncatrice a doppia testa FOM Blitz ALVA 500
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-cyan-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-cyan-700">
                            Pressa piegatrice Novastilmec NP/75
                          </h4>
                        </div>
                        <div className="p-3 bg-white rounded-xl border border-cyan-100 shadow-sm transition-shadow hover:shadow-md">
                          <h4 className="font-bold text-cyan-700">
                            Laser Optimo Prima Industrie 3D
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bottom Message */}
                <div className="p-6 mt-8 bg-white rounded-2xl border-l-4 border-purple-500 shadow-sm">
                  <p>
                    Ogni attività gestita esternamente è sempre monitorata
                    attentamente dal nostro Personale: il reparto di Controllo
                    Qualità verifica attentamente e dimensionalmente i
                    particolari realizzati e il rispetto delle specifiche
                    richieste. La consegna verso il Cliente è trattata
                    rispettando le specifiche GP12.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Produzione;
